module.exports = __webpack_public_path__ + "static/media/GUIDE_0010_01.5e632500.jpg";